import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { APP_CONFIG, AppConfigFactory, ConfigurationsService } from '@icc/common';
import { ICC_PAGE_DATA, PageComponent } from '@icc/helpers';
import { iccListItem } from '@icc/configurator/ui';
import { IccAccessoryColor, IccAccessoryAccessory } from '@icc/common/data-types';
import { _, SharedFacade } from '@icc/configurator/shared';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ColorMappingService } from '@icc/common/colors/colors-mapping.service';
import { KeysService } from '../cylinders-page/keys.service';

@Component({
  selector: 'icc-hardware-type-options-page',
  templateUrl: './hardware-type-options-page.component.html',
  styleUrls: ['./hardware-type-options-page.component.scss']
})
export class HardwareTypeOptionsPageComponent extends PageComponent implements OnInit {
    public title: string = _('WINDOW|Opcje osprzętu');
    selectedType: IccAccessoryAccessory | null = null;
    colors: iccListItem[] = [];
    selColor = '0';
    defaultColor = false;

    maxKeyQuantity = 0;
    keyPrice = 0;

    selectedTypeImg = '';

    cylinderKeysForm: FormGroup;

    constructor(
        @Inject(APP_CONFIG) public config: AppConfigFactory,
        private sharedFacade: SharedFacade,
        @Inject(ICC_PAGE_DATA)
        private pageData: {
            title: string;
            selectedType: IccAccessoryAccessory;
            hardwareColors?: IccAccessoryColor[];
            selColor: IccAccessoryColor;
        },
        private configurationsService: ConfigurationsService<'door'>,
        private colorsMappingService: ColorMappingService,
        private fb: FormBuilder,
        private keysService: KeysService,
    ) {
        super();
        this.title = pageData.title;
    }

    ngOnInit() {
        this.selectedType = this.pageData.selectedType;
        this.selColor = this.pageData.selColor && this.pageData.selColor.id;
        this.defaultColor = Boolean(this.pageData.selColor && this.pageData.selColor.isDefault);
        this.colors = !this.pageData.hardwareColors ? [] : this.pageData.hardwareColors
            .filter(
                color =>
                    this.selectedType
                    && this.selectedType.colors_ids
                    && this.selectedType.colors_ids.some(id => Number(id) === Number(color.id))
            )
            .map(color => ({
                id: color.id,
                title: color.name,
                color: '#' + color.color,
                imageUrl: '/files/windowhandlescolor/' + color.color_img,
            }));
        this.setDefaultColors();
        this.selectedTypeImg = this.getImageUrl(this.selectedType, this.selColor);

        if(this.selectedType.type === 'cylinder') {
            this.cylinderKeyForm();
            this.keyPrice = this.selectedType.key_price;
            this.maxKeyQuantity = Number(this.selectedType.max_key_quantity);
        }
    }


    cylinderKeyForm(conf = this.configurationsService.conf.Current.doorHardware.cylinders) {
        const mainLock = conf.keyQuantityForMainLock;
        const additionalLock = conf.keyQuantityForAdditionalLock;

        this.cylinderKeysForm = this.fb.group({
            key: [
                this.selectedType.fits_the_lock ? additionalLock : mainLock,
                Validators.compose([
                    Validators.min(0),
                    Validators.max(this.selectedType.max_key_quantity),
                ]),
            ],
        });
    }

    private setDefaultColors() {
        if (((this.pageData.selectedType && this.pageData.selectedType.colors_ids) || []).map(String).indexOf(this.selColor) === -1) {
            const hardwareColorsIds = ((this.pageData.selectedType && this.pageData.selectedType.colors_ids) || []).map(Number);
            const windowColorId = this.colorsMappingService.getWindowColorId(
                this.configurationsService.conf.Current
            );
            const matchedColors = this.colorsMappingService.getColors(
                Number(windowColorId),
                'window',
                'accessory'
            );
            const colors = matchedColors
                .map(m => hardwareColorsIds.filter(c => c === m)[0])
                .filter(m => m);
            if (colors.length) {
                this.selColor = String(colors[0]);
            } else {
                this.selColor = String(hardwareColorsIds[0]);
            }
            this.defaultColor = true;
        }
    }

    private getImageUrl(hardware: IccAccessoryAccessory, selectedColor: string): string {
        return hardware && (hardware.colors_imgs && hardware.colors_imgs[selectedColor]
            ? '/files/windowhingescolorswindowaccessory/' + hardware.colors_imgs[selectedColor]
            : '/files/windowaccessory/' + hardware.img);
      }

    selectColor(colorItem: iccListItem) {
        const type = this.pageData.selectedType;
        const color = this.pageData.hardwareColors.find(c => c.id === colorItem.id);
        if (type && color) {
            this.selColor = color.id;
            this.defaultColor = false;
            this.selectedTypeImg = this.getImageUrl(type, this.selColor);
        }
    }

    save() {
        if(this.selectedType.type === 'cylinder'){ 
            const keyQuantity = this.cylinderKeysForm.get('key').value;

            if (keyQuantity) {
                this.keysService.setKeyQuantityForCylinder(keyQuantity, this.selectedType);
            } else {
                this.keysService.setKeyQuantityForCylinder(0, this.selectedType);
            }
        }

        this.sharedFacade.closePage({
            type: this.pageData.selectedType,
            color: this.selColor,
            defaultColor: this.defaultColor,
        });
    }
}
